module.exports = __webpack_public_path__ + "img/sin-delantal.6ff4902b.png";